/* eslint-disable import/prefer-default-export */
import { provideLocal, toValue } from '@vueuse/core';
import { useInitUpc, UpcParser as upcParser } from '@common-vue/media-card-large';
import { useFlagsProvide } from '@modules/featureControl/composables/useFlagsProvide';
import { PRODUCT_ID_REPOSITORY, PRODUCT_DATA_REPOSITORY } from '../constants';

/**
 * * Product Data Provider
 * ! Dependency Injection of product data
 * Reduces complexity, removes prop drilling, increases performance
 * Plus, allows avoid unnecessary computed wraps
 * @param {ProductId} productId
 * @param {Product} productData
 */
export const useProductProvide = (productId, productData) => {
  provideLocal(PRODUCT_ID_REPOSITORY, productId);
  provideLocal(PRODUCT_DATA_REPOSITORY, toValue(productData));

  useFlagsProvide();
  useInitUpc({ id: productId, data: upcParser(productData) });
};
